<template>
	<div class="a-header">
		<div class="wrapper">
		<div class="content">

		<div class="company">{{company}}</div> 
		<h1 class="title">{{title}}</h1> 
		<div class="body">{{body}}</div> 
		<slot name="cta">
			<div class="enrollment-card" v-if="!hideCTA">
				<a-enrollment-card />
			</div>
		</slot>
		</div>
		<div class="media">
			<slot name="media">
				<img class="header-banner" :src="image" />
			</slot>
		</div>
		</div>
	</div>
</template>
<script>
import AEnrollmentCard from '@/components/a-enrollment-card'
export default {
	components: {
		AEnrollmentCard
	},
	props: {
		company: String,
		title: String,
		body: String,
		image: String,
		hideCTA: Boolean,
	}
}
</script>
<style lang="scss" scoped>
	.a-header {
		color: $white;
		background: $navy;
		margin: 0 auto 130px;
		position: relative;
	}
	.wrapper {
		max-width: 1580px;
		padding: 50px 100px;
		margin: auto;
		display: grid;
		grid-template-rows: 1fr;
		grid-template-columns: 1fr 1fr;
    column-gap: 60px;
		@media(max-width: 800px) {
      display: block;
			padding: 20px 50px;
		}
	}
	.content {
		width: 100%;
		padding-bottom: 40px;
		@media(max-width: 1000px) {
			padding-right: 0;
			grid-column: 1/3;
		}
	}
	.company {
		color: $white;
		font-family: 'Amsi Pro';
		font-weight: bold;
		font-size: 3em;
		margin-top: 20px;
	}
	.title {
		color: $teal;
		font-weight: bold;
		font-size: 4.05em;
		margin-top: 20px;
	}
	.body {
		margin-top: 20px;
		font-size: 20px;
		color: $white;
	}
	.media {
		max-width: 650px;
		width: 100%;
		position: relative;
		display: flex;
		right: 0;
		bottom: -100px;
		left: 0;
		align-items: flex-end;
		justify-content: flex-end;
    z-index: 2;
		@media(max-width: 1000px) {
			max-width: 100%;
			grid-column: 1/3;
		}

	}
	.header-banner {
		width: 100%;
		max-width: 470px;
		right: 0;
		margin-top: -100px;
	}
</style>
